import MobileAppConfiguration from "./mobileAppConfiguration";
import ReturnsNullOn404 from "common/http/returnsNullOn404";
import AdminHttpService from "admin/common/adminHttpService";

class MerchantFileService extends AdminHttpService {
    @ReturnsNullOn404()
    async getMobileAppConfig(merchantId: string): Promise<MobileAppConfiguration> {
        const response = await this.getClient(merchantId).get<MobileAppConfiguration>('/settings/v1/files/public/mobile/app-config.json');
        return response.data;
    }

    async updateMobileAppConfig(merchantId: string, config: MobileAppConfiguration): Promise<any> {
        await this.getClient().put(`/settings/v1/merchants/${merchantId}/mobile-app-config`, config);
    }
}

const merchantFileService = new MerchantFileService();

export default merchantFileService;